import { AbstractControl, FormArray, FormGroup, ValidationErrors } from '@angular/forms';
import { PTOConfig } from '../../../../../models/paid-time-off';
import * as _ from 'underscore';
import { ArrayEqualsIgnoreOrder } from '../../../../../utils/math';

export function NoDuplicateAccrualPeriods(array: FormArray): ValidationErrors {
  let monthCounts: number[] = [];

  for (let val of array.value) {
    if (val.AccruePeriod == 0) {
      //months
      if (!monthCounts.some(x => x == val.AccrueAfter)) {
        //this month count isn't already in the list. Add it.
        monthCounts.push(val.AccrueAfter);
      } else {
        return { DuplicateAccrualPeriods: true };
      }
    } else {
      //Year
      const inMonths = val.AccrueAfter * 12;
      if (!monthCounts.some(x => x == inMonths)) {
        //this month count isn't already in the list. Add it.
        monthCounts.push(inMonths);
      } else {
        return { DuplicateAccrualPeriods: true };
      }
    }
  }
  return null;
}

export function MustHaveAtLeastOne(array: FormArray): ValidationErrors {
  if (array.length < 1) {
    return { MustHaveAtLeastOne: true };
  }
  return null;
}

export function CannotActivateInactivePlan(
  ptoConfigs: PTOConfig[]
): (formControl: FormGroup) => ValidationErrors {
  return (formControl: FormGroup) => {
    if (ptoConfigs == null) {
      return null;
    }
    const planId = formControl.get('Id').value;
    if (planId == null) {
      return null;
    }
    const plan = ptoConfigs.find(x => x.Id == planId);

    const activeState = formControl.get('Active').value;
    if (!plan.IsActive && activeState) {
      return { CannotActivateInactivePlan: true };
    }
    return null;
  };
}

export function MustBeUnique(
  ptoConfigs: PTOConfig[]
): (formControl: FormGroup) => ValidationErrors {
  var tmpConfigs = ptoConfigs.map(conf => {
    return {
      ...conf,
      TimeoffRates: conf.TimeoffRates.map(rate => {
        return {
          ...rate,
          AccruePeriodDescription: null, // this field does not exist on EmployeeRates object, it is just a label
          SequenceNumber: null // Ignore sequence number, see notes below
        };
      })
    };
  });

  return (formControl: FormGroup) => {
    if (!formControl.value.OverrideClientRates) {
      // Not overridden, pass
      return null;
    }

    var config = tmpConfigs.find(conf => conf.Id == formControl.value.Id);
    if (config.TimeoffRates.length != formControl.value.EmployeeRates.length) {
      // Early out, if these arrays have different lengths, the user has definitely overridden something
      return null;
    }

    // We don't care about sequence number, a user might enter values out of order, or when we add
    // a new rate it gets a sequence number of zero, which means it will never match an existing config
    // unless we don't match on sequence number
    var tmp = formControl.value.EmployeeRates.map(rate => {
      return { ...rate, SequenceNumber: null, AccruePeriodDescription: null };
    });

    // Rates may be out of order, so we need to do a comparison on all items of the arrays
    if (ArrayEqualsIgnoreOrder(config.TimeoffRates, tmp)) {
      return { NotUniqueOverrides: true };
    }

    return null;
  };
}
